module.exports = __webpack_public_path__ + "static/media/JPEG.bae3b25d.png";